import { render, staticRenderFns } from "./EditPersonPortalModal.vue?vue&type=template&id=5b43445a&"
import script from "./EditPersonPortalModal.vue?vue&type=script&lang=js&"
export * from "./EditPersonPortalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports